import type { CreditBalance } from './types.no-deps'
import type { Nullable } from '../../lib/typeHelpers.no-deps'
import type { CamelCaseFlags } from '../../cfg/flags.no-deps'

export function isCreditBalanceVeryLow(creditBalance: Nullable<CreditBalance>, creditsCost: number) {
    return creditBalance && creditBalance.totalBalance < creditsCost
}

export function isCreditBalanceSufficient(
    creditBalance: Nullable<CreditBalance>,
    creditsCost: number,
    userIsZapticStaff: boolean,
    featureFlags: CamelCaseFlags
) {
    return !featureFlags.aiCredits || !creditBalance || userIsZapticStaff || creditBalance.totalBalance >= creditsCost
}
